import { render } from "./ProjectsGrid.vue?vue&type=template&id=e0d85ee6"
import script from "./ProjectsGrid.vue?vue&type=script&lang=js"
export * from "./ProjectsGrid.vue?vue&type=script&lang=js"

import "./ProjectsGrid.vue?vue&type=style&index=0&id=e0d85ee6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__